module.exports = __webpack_public_path__ + "static/media/avatar_eagle.f16c04ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_eagle.png
// module id = 377
// module chunks = 0